import { useState } from 'react';

type PH = { key: string; ex: string; desc: string };

const DINAMICOS: PH[] = [
  { key: 'date', ex: '03/06/2026', desc: 'Data de hoje (dia/mês/ano — formato BR).' },
  { key: 'date_us', ex: '06/03/2026', desc: 'Data de hoje (mês/dia/ano — formato americano).' },
  { key: 'datetime', ex: '03/06/2026 14:30', desc: 'Data e hora de agora.' },
  { key: 'mes_ano', ex: '06/2026', desc: 'Mês/ano atual, sem o dia.' },
  { key: 'anomes', ex: '202606', desc: 'Ano+mês juntos (AAAAMM). Útil pra concatenar/numerar — muda a cada mês.' },
  { key: 'now', ex: '2026-06-03T14:30:00-03:00', desc: 'Data/hora completa (formato ISO).' },
];

const EMAIL: PH[] = [
  { key: 'email_from', ex: 'cliente@empresa.com', desc: 'E-mail de quem enviou a mensagem.' },
  { key: 'email_from_name', ex: 'João Silva', desc: 'Nome de quem enviou.' },
  { key: 'email_subject', ex: 'Fatura de junho', desc: 'Assunto do e-mail recebido.' },
  { key: 'email_body', ex: '(texto do e-mail)', desc: 'Corpo do e-mail recebido.' },
];

function Row({ p }: { p: PH }) {
  return (
    <div className="py-1.5 border-b last:border-0">
      <code className="bg-slate-100 rounded px-1 text-xs">{`{{ ${p.key} }}`}</code>
      <span className="text-xs text-slate-400 ml-2">ex: {p.ex}</span>
      <div className="text-sm text-slate-600">{p.desc}</div>
    </div>
  );
}

/** Link "ver placeholders" + modal com a lista e descrições. Coloque onde se usa {{ }}. */
export default function PlaceholdersHelp({ className = '' }: { className?: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={`text-xs text-brand-600 hover:underline ${className}`}
        onClick={() => setOpen(true)}
      >
        ver placeholders disponíveis
      </button>
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[80vh] overflow-auto p-4 space-y-3"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-semibold">Placeholders disponíveis</h3>
              <button className="text-slate-400 hover:text-slate-700" onClick={() => setOpen(false)}>✕</button>
            </div>
            <p className="text-xs text-slate-500">
              Use no formato <code className="bg-slate-100 rounded px-1">{'{{ nome }}'}</code> no assunto,
              corpo ou no documento anexado. São substituídos na hora do envio.
            </p>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1">Sempre disponíveis</h4>
              {DINAMICOS.map((p) => <Row key={p.key} p={p} />)}
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-1">
                Só em regras por “e-mail recebido”
              </h4>
              {EMAIL.map((p) => <Row key={p.key} p={p} />)}
            </div>

            <p className="text-xs text-slate-500">
              Placeholders que você criar no próprio documento (ex: <code className="bg-slate-100 rounded px-1">{'{{ nome }}'}</code>)
              viram campos pra preencher com valor fixo.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
